var map = {
	"./DD1.jpg": 9672,
	"./DD2.jpg": 3548,
	"./DD3.jpg": 6526,
	"./HS1.jpg": 489,
	"./MLS1.jpg": 2598,
	"./PD1.jpg": 3069,
	"./PD2.png": 6860,
	"./SRB1.jpg": 6625,
	"./TC1.jpg": 9771,
	"./project-1.jpg": 4885,
	"./project-2.jpg": 182,
	"./project-3.jpg": 33,
	"./project-4.jpg": 8147,
	"./project-5.jpg": 9490,
	"./project-6.jpg": 4419,
	"./project-7.jpg": 4181,
	"./project-8.jpg": 2826,
	"./project-case-study-thumb.jpg": 937,
	"./project-figure-1.jpg": 1355,
	"./project-figure-2.jpg": 1980
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5289;